module.exports = __webpack_public_path__ + "static/media/Eia.5c026d15.png";